<section class="min-vh-100 overflow-hidden position-relative d-flex align-items-center pt-5 pt-md-0 hero-section">

  <!-- OVERLAY -->
  <div class="position-absolute top-0 start-0 w-100 h-100 hero-overlay z-1"></div>

  <!-- CONTENT -->
  <div class="container-fluid px-3 px-md-4 px-lg-5 position-relative z-2">
    <div class="row align-items-center justify-content-center">

      <!-- LEFT -->
      <div class="col-12 col-lg-6 text-dark text-center text-lg-start d-flex flex-column align-items-center align-items-lg-start">

        <!-- BADGE -->
        <div
          v-if="hero_data.badge_text"
          class="d-inline-flex align-items-center gap-2 badge rounded-pill badge-sanass mb-4 px-3 py-2 mx-auto mx-lg-0"
        >
          <span class="badge-dot"></span>
          <span>{{ hero_data.badge_text }}</span>
        </div>

        <!-- HEADLINE -->
        <h1 class="fw-bold display-4 mb-3">
          {{ hero_data.headline_prefix }}
          <span class="text-highlight">{{ hero_data.headline_highlight }}</span><br />
          {{ hero_data.headline_suffix }}
        </h1>

        <!-- DESCRIPTION -->
        <p class="lead mb-4 mx-auto mx-lg-0" style="max-width: 720px;">
          {{ hero_data.description }}
        </p>

        <!-- CTA -->
        <div class="d-flex flex-column flex-sm-row gap-3 mb-4 justify-content-center justify-content-lg-start w-100">
          <router-link
            :to="hero_data.primary_cta.route"
            class="btn btn-warning btn-lg fw-semibold px-4 rounded-3"
          >
            {{ hero_data.primary_cta.text }}
          </router-link>

          <a
            v-if="hero_data.secondary_cta"
            :href="hero_data.secondary_cta.href"
            class="btn btn-light btn-lg fw-medium px-4 rounded-3"
          >
            {{ hero_data.secondary_cta.text }}
          </a>
        </div>

        <!-- TRUST -->
        <div class="d-flex flex-wrap gap-4 small justify-content-center justify-content-lg-start w-100">
          <div
            v-for="item in hero_data.trust_indicators"
            :key="item.key"
            class="d-flex align-items-center gap-2"
          >
            <i :class="item.icon"></i>
            <span>{{ item.label }}</span>
          </div>
        </div>

      </div>

      <!-- RIGHT (HIDE ON md and smaller) -->
      <div class="col-12 col-lg-6 d-none d-lg-flex justify-content-center mt-5 mt-lg-0">

        <div class="compliance-card p-4 p-lg-5 rounded-4 text-dark position-relative w-100">

          <!-- DOCUMENTS -->
          <div class="document-badge d-flex align-items-center gap-2 p-3 rounded-4">
            <i :class="hero_data.compliance.documents.icon"></i>
            <div class="lh-sm">
              <strong>{{ hero_data.compliance.documents.count }}</strong>
              <div class="small">{{ hero_data.compliance.documents.label }}</div>
            </div>
          </div>

          <!-- HEADER -->
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h6 class="mb-0 fw-semibold">{{ hero_data.compliance.title }}</h6>
            <span class="text-warning fw-semibold">{{ hero_data.compliance.level }}</span>
          </div>

          <!-- SCORE -->
          <div class="score-circle d-flex align-items-center justify-content-center mx-auto mb-4">
            <div class="d-flex flex-column align-items-center justify-content-center text-center">
              <div class="display-6 fw-bold">{{ hero_data.compliance.score }}</div>
              <div class="small">{{ hero_data.compliance.score_label }}</div>
            </div>
          </div>

          <!-- BREAKDOWN -->
          <div class="row text-center">
            <div
              class="col"
              v-for="item in hero_data.compliance.breakdown"
              :key="item.key"
            >
              <div class="fw-bold fs-5">{{ item.value }}</div>
              <div class="small">{{ item.label }}</div>
            </div>
          </div>

          <!-- TREND -->
          <div class="trend-badge d-flex align-items-center gap-2 p-3 rounded-4">
            <i :class="hero_data.compliance.trend.icon"></i>
            <div class="lh-sm">
              <strong>{{ hero_data.compliance.trend.value }}</strong>
              <div class="small">{{ hero_data.compliance.trend.label }}</div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</section>
